// Google Analytics Tracking ID
export const TRACKING_ID = "G-2YYXN6MF8T";

// Google Tag Manager ID
export const GTM_ID = "AW-16877236232";
